import { i18n } from '../i18n/i18n';
import { IDs } from '../helpers/IDs';
import { LoginBestimmungen } from './LoginBestimmungen';
import * as React from 'react';
import { WFormsTableWrapper } from '../core/table/WFormsTableWrapper';

interface FormAddNewToolProps extends React.ClassAttributes<any> {
    containerId?: string;
    data: any;
}

interface FormAddNewToolState extends React.ClassAttributes<any> {
    keyAddon: number;
    alleRegiBedingungenChecked: boolean;
}

export class FormAddNewTool extends React.Component<FormAddNewToolProps, FormAddNewToolState> {

    constructor(props: any) {
        super(props);
        this.state = {
            keyAddon: 0,
            alleRegiBedingungenChecked: false
        };
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                containerId={this.props.containerId}
                key={`register_new_tool_${this.state.keyAddon}`}
                formTitel='Ein neues Tool anlegen'
                entity={IDs.ENT_REGISTRIERUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                formLayout='flowV2'
                customClass={'Custom-ETA'}
                preFilterServer={{ tid: 0 }}
                directEditFormularOf={{ tid: 0 }}
                inlineFormular={true}
                validRestriction={'stop'}
                validateField={this.customValidate}
                formPreset={{
                    mail_confirmed: 1,
                    active: 1,
                    mandant_key: 'authorized_new_customer_tool'
                }}
                customFormConfig={{
                    mail: { hidden: true },
                    password: { hidden: true }
                }}
                customCssStyle={{ outerStyle: { backgroundColor: 'white' } }}
                formSimpleValidationMsg={['unternehmen', 'bereich_key']}
                formGroupOrder={[
                    {
                        title: i18n('Pflichtangaben', 'sys'),
                        titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                        foldable: false,
                        folded: false,
                        fields: ['unternehmen', 'bereich_key', 'mail', 'password']
                    },
                    {
                        title: i18n('Optionale Angaben', 'sys'),
                        titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                        foldable: true,
                        folded: true,
                        fields: ['name', 'vorname', 'strasse', 'hausnummer', 'ort', 'plz', 'telefon']
                    }
                ]}
                bundleFilterFunc={this.filterBundle}
                extraFormElementAfter={{
                    password: <div style={{ marginBottom: 30, paddingRight: 10 }}>
                        <LoginBestimmungen
                            onChange={(allChecked: boolean) => this.setState({ alleRegiBedingungenChecked: allChecked })}
                        />
                    </div>
                }}
                callBeforeOnFormSave={(data: any, callback: () => void) => {
                    if (!this.state.alleRegiBedingungenChecked) {
                        alert('Bitte akzeptieren Sie Nutzungsbedingungen und Datenschutzhinweise !');
                    } else {
                        callback();
                    }
                }}
                onAfterAction={(action: string) => {
                    if (action.startsWith('closeForm')) {
                        this.setState({ keyAddon: this.state.keyAddon + 1 });
                    }
                    if (action === 'saveDone') {
                        alert('Sie haben ein neues Tool erfolgreich angelegt. Sie können dieses Tool bei Ihrer nächsten Anmeldung verwenden.');
                    }
                }}
            />
        );
    }

    filterBundle(bundle: any) {
        bundle.bereich_key = bundle.bereich_key.filter((item: any) => item.intern_key !== 'kommunalverwaltung');
    }

    customValidate(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        if (key === 'name') {
            if (value && value !== '') {
                const newVal = value.replace(/[^A-Za-zöäüÖÄÜß\-]/g, '');
                if (newVal !== value) {
                    onValueChange('name', newVal);
                }
            }
        }
        if (key === 'vorname') {
            if (value && value !== '') {
                const newVal = value.replace(/[^A-Za-zöäüÖÄÜß\-\. ]/g, '');
                if (newVal !== value) {
                    onValueChange('vorname', newVal);
                }
            }
        }
        if (key === 'plz') {
            if (value && value !== '') {
                const newVal = value.replace(/[^0-9]/g, '').substr(0, 5);
                if (newVal !== value) {
                    onValueChange('plz', newVal);
                }
            }
        }
        if (key === 'telefon') {
            if (value && value !== '') {
                const newVal = value.replace(/[^0-9+-/]/g, '');
                if (newVal !== value) {
                    onValueChange('telefon', newVal);
                }
            }
        }
        return undefined;
    };
}
